module.exports = __webpack_public_path__ + "assets/img/xbox-yuyue-hover-4aa2fb09.png";